
    import { localeIncludes } from "./../../helpers/node_gm_common"
    import { debounce } from "lodash"
    import { mapGettersTS } from "../../helpers/vuex"
    import { mapGetters, mapActions, mapMutations } from "vuex"
    import { IPrompt } from "@/types"
    import { defineComponent, PropType } from "vue"
    import List from "../misc/list/List.vue"
    import { Getters } from "@/store/getters"
    import Prompt from "./Prompt.vue"
    import ls from "local-storage"
    import Accordeon from "@/components/misc/Accordeon.vue"

    export default defineComponent({
        props: {
            tab: {
                type: String,
            },

        },
        components: {
            Prompt,
            // InputCheckbox,
            List,

        },
        data() {
            return {
                search: "",
                isLoading: false,
                newPrompt: {
                    id: -1,
                    name: "",
                    content: "",
                    categories_ids: []
                }
            }
        },
        computed: {
            needMore(): boolean {
                if (this.tab === "own") {
                    return this.myPrompts.count > this.myPrompts.items?.length
                } else if (this.tab === "my") {
                    return false
                } else {
                    return this.$store.getters.prompts?.count > this.$store.getters.prompts?.items?.length
                }
            },

            ...mapGetters(["promptsLoading", "user", "isModer", "myPrompts", "favorites"]),
            prompts(): IPrompt[] {
                const prompts = this.$store.getters.prompts
                if (this.tab === "my") {
                    return this.favorites
                } else if (this.tab === "own") {
                    return this.myPrompts.items
                } else {
                    return prompts.items
                }
            },

            getters(): Getters {
                return this.$store.getters
            },
        },
        methods: {
            async addItem(item: Partial<IPrompt>) {
                const category = this.getters.categories.find((category) => category.name === "Common")
                const res = await this.addPrompt({ name: item.name, content: item.content, categories_ids: [...(item.categories_ids || []), category?.id] })
                if (!this.isModer) {
                    this.ADD_MY_PROMPT(res)
                }
                this.newPrompt.name = ""
                this.newPrompt.content = ""
                this.newPrompt.categories_ids = []
            },

            doSearch: debounce(function(value: string) {
                // @ts-ignore
                if (this.tab === "own") {
                    // @ts-ignore
                    this.getMyPrompts({ q: value })
                // @ts-ignore
                } else if (this.tab === "my") {
                    // @ts-ignore
                    this.SET_FAVORITES(this.favorites.filter((favorite) => localeIncludes(favorite.name, value) || (favorite.content && localeIncludes(favorite.content, value))))
                } else {
                    // @ts-ignore
                    this.getPrompts({ categoryId: this.$route.params.category, q: value })
                }
            }, 100),

            ...mapMutations(["ADD_MY_PROMPT", "DEL_MY_PROMPT", "SET_FAVORITES"]),
            async loadMore() {
                this.isLoading = true
                try {
                    if (this.tab === "own") {
                        await this.addMyPrompts({ start: this.myPrompts.items.length, q: this.search })
                    } else {
                        await this.addPrompts({ start: this.$store.getters.prompts.items.length, q: this.search })
                    }
                } catch (e) {
                    console.error(e)
                } finally {
                    this.isLoading = false
                }
            },

            ...mapActions(["delPrompt", "editPrompt", "addPrompt", "addPrompts", "addMyPrompts", "getPrompts", "getMyPrompts", "getFavorites"]),
            del(item: IPrompt) {
                this.delPrompt(item.id)
                if (!this.isModer) {
                    this.DEL_MY_PROMPT(item.id)
                }
            },

            // edit(item: IPrompt, field: string, val: any) {
            //     // @ts-ignore
            //     this.editPrompt({ id: item.id, field, value: val })
            // },
            edit: debounce(function(item: IPrompt, field: string, val: any) {
                if (+item.id === -1) {
                    // @ts-ignore
                    this.newPrompt[field] = val
                } else {
                    // @ts-ignore
                    this.editPrompt({ id: item.id, field, value: val })
                }
            }, 150),
        },

        watch: {
            tab: {
                handler (newVal, oldVal) {
                    this.search = ""
                    if (oldVal === "own") {
                        this.getMyPrompts({})
                    } else if (oldVal === "my") {
                        const byIds = (ls as any)("my") || []
                        byIds.length && this.getFavorites({ byIds })
                    } else {
                        this.getPrompts({ categoryId: this.$route.params.category })
                    }
                }
            },
            "$route.params.category": function () {
                this.search = ""
            }
        },
    })

    